import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Report, ReportParams } from './reports.model';

@Injectable()
export class ReportsService {

    constructor(private _httpClient: HttpClient) { }


    getReports(category: string): Observable<Report[]>{
        // const headers = { 'withCredentials':'true' }
        return this._httpClient.get<Report[]>('/ypm/api/fm/report/' + category);
    }


    generateReports(reporParams: ReportParams){
        // const headers = { 'withCredentials':'true' }
        return this._httpClient.put('/ypm/api/fm/report', reporParams);
    }

}
